import React, { useState, useEffect } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import PageTitle from "components/PageTitle";
import { userTypesCaregivers } from "config/constants";
import { SITE_KEY } from "config/recaptcha";
import CaregiversRegistrationForm from "./CaregiversRegistrationForm";

const CaregiversRegistration = (props) => {
  const [title, setTitle] = useState("");

  const getTitle = (slug) => {
    const item = userTypesCaregivers.find((item) => item.slug === slug);
    return item.title;
  };

  useEffect(() => {
    const title = getTitle(props.match.params.slug);
    setTitle(title);
  });

  return (
    <div className="page-body">
      <PageTitle align="center" isBackButton={true}>
        {title}
      </PageTitle>

      <div className="content-container">
        <div className="container">
          <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}>
            <CaregiversRegistrationForm slug={props.match.params.slug} />
          </GoogleReCaptchaProvider>
        </div>
      </div>
    </div>
  );
};

export default CaregiversRegistration;
